import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  styleUrls: ['./accordion-panel.component.scss']
})
export class AccordionPanelComponent {

  @Input() isHidden = true;
  @Input() title: string;
  @Input('class') style: string;

}
